import { Image } from "./canvas.js"
import { ConfigCmd, Item, Shape } from "dsabp-js"
import { BpRenderer } from "./index.js"

export type Hull = "HULL_CORNER" | "HULL_H" | "HULL_V"

export const TileFace = {
	Top: 1,
	Right: 2,
	Bottom: 4,
	Left: 8
}
export type TileFace = typeof TileFace[keyof typeof TileFace]


export type RendererResolver = ({ main, item, shape, config, other }: RendererResolverParams) => Renderer

export type RendererResolverParams = {
	main: BpRenderer;
	toRel?: InstanceType<typeof BpRenderer>["toRel"],
	item: Item;
	shape?: Shape;
	config?: Partial<ConfigCmd>;
	other?: any
}


export interface Renderer {
	discriminator: string
	render: () => Promise<RenderResult[]> | RenderResult[]
}

export interface RenderResult {
	layer?: "main" | "top"
	image: Image

	texturePosOff?: { x: number, y: number },

	textureSizeOff?: { x: number, y: number },

	baseBoundOff?: { x: number, y: number },
	sx?: number
	sy?: number
	sw?: number
	sh?: number
}
